import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "add_task_modal",
  ref: "addTaskModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center p-2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Add New Task"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fw-bold fs-7" }, " Add custom or use existing IBO tasks. ")
], -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "col-4 d-flex flex-column fv-row"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-7 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Task Name")
], -1)
const _hoisted_13 = {
  key: 1,
  class: "col-4 d-flex flex-column fv-row"
}
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-7 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Task Name")
], -1)
const _hoisted_16 = { class: "col d-flex flex-column fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-7 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Merchants"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Choose a group"
  })
], -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-9 d-flex flex-column fv-row" }
const _hoisted_20 = { class: "row mb-5" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "w-auto text-muted" }
const _hoisted_23 = {
  class: "collapse mt-1",
  id: "kt_advanced_search_form"
}
const _hoisted_24 = { class: "d-flex flex-column mb-2 fv-row" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col justify-content-between" }
const _hoisted_27 = { class: "col justify-content-between" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = {
  type: "submit",
  ref: "submitButtonRef",
  class: "btn btn-lg btn-primary"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            id: "add_task_modal_form",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.targetData,
            ref: "formRef",
            class: "form"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_ctx.targetData.task_group === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_el_form_item, { prop: "name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              disabled: "",
                              placeholder: "Enter name of task"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_el_form_item, { prop: "name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.targetData.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.name) = $event)),
                              placeholder: "Enter name of task",
                              name: "name"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ])),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_form_item, { prop: "merchant_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.merchant_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.merchant_id) = $event)),
                        "default-first-option": "",
                        placeholder: "Choose one of your merchants..."
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.merchants, (merchant, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: merchant.mid_number,
                              value: merchant.merchant_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_el_switch, {
                          "active-text": "Task Group",
                          modelValue: _ctx.targetData.task_group,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.task_group) = $event)),
                          style: {"--el-switch-on-color":"#409eff","--el-switch-off-color":"#bec1c7"},
                          "data-bs-toggle": "collapse",
                          href: "#kt_advanced_search_form"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.targetData.privacy_policy,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.privacy_policy) = $event)),
                        label: "Privacy Policy",
                        value: "Privacy Policy",
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.targetData.pricing_recurring,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetData.pricing_recurring) = $event)),
                        label: "Pricing and Recurring Billing",
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.targetData.website_content,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.targetData.website_content) = $event)),
                        label: "Website Marketing Content",
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.targetData.products_sold,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.targetData.products_sold) = $event)),
                        label: "Products Sold",
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.targetData.merchant_account,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.targetData.merchant_account) = $event)),
                        label: "Associated Merchant Account",
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.targetData.payment_processor,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.targetData.payment_processor) = $event)),
                        label: "Associated Payment Processor",
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.targetData.terms_conditions,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.targetData.terms_conditions) = $event)),
                        label: "Terms and Conditions",
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", _hoisted_29, _hoisted_32, 512)
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ], 512))
}